export enum PathsFund {
  Fund = 'fund',
  Create = 'create',
  Pools = 'pools',
  Employees = 'employees',
  Pool = 'pool',
  Login = 'login',
  Edit = 'edit',
}
